// hooks/useLeadTimePricing.js
import { useParams } from "react-router-dom";
import { useAuth, getISODate } from "../../sdk";
import { useState, useCallback } from "react";

export function useLeadTimePricing(selectedDate) {
  const { hotelId } = useParams();
  const { authFetch, setCloneMessage } = useAuth();
  const [leadTimeData, setLeadTimeData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchLeadTimePricing = useCallback(async () => {
    if (!selectedDate || !hotelId) return;

    setIsLoading(true);
    setError(null);
    const dateString = getISODate(selectedDate).split("T")[0];

    try {
      const { get } = await authFetch({
        path: `/hotel/${hotelId}/lead-time-vs-bob/date/${dateString}`,
      });

      const { data, response, error } = await get();

      if (response?.ok && data) {
        setLeadTimeData(data);
      } else {
        console.error("Error fetching lead time pricing data:", error);
        setLeadTimeData(null);
        const message =
          error?.message ||
          "Failed to load lead time pricing data. Please try again.";
        setError(message);
        setCloneMessage(message);
      }
    } catch (error) {
      console.error("Exception fetching lead time pricing:", error);
      setLeadTimeData(null);
      const message =
        error?.message ||
        "Something went wrong while loading lead time pricing.";
      setError(message);
      setCloneMessage(message);
    } finally {
      setIsLoading(false);
    }
  }, [selectedDate, hotelId, authFetch, setCloneMessage]);

  return { fetchLeadTimePricing, leadTimeData, isLoading, error };
}
